import { ReactNode } from 'react';

import * as S from './styles';
export interface FormProps {
  children: ReactNode;
  title?: string;
  bgcolor?: 'default' | 'white';
}

const Form = ({ children, title, bgcolor = 'default' }: FormProps) => {
  return (
    <S.Container bgcolor={bgcolor}>
      {title && <S.Title>{title}</S.Title>}
      <S.Form>{children}</S.Form>
    </S.Container>
  );
};

export default Form;
